module.exports = __webpack_public_path__ + "static/img/recognition2.e467b19f.png";